import { render, staticRenderFns } from "./GlobalFeatureConfig.vue?vue&type=template&id=f9942722"
import script from "./GlobalFeatureConfig.js?vue&type=script&lang=js&external"
export * from "./GlobalFeatureConfig.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports